import React, { useEffect, useState } from "react";
import axios from "axios";

const CharacterImage = ({ filename, name, style }) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await axios.get(
          `/api/stories/imagefile/${filename}`,
          {
            responseType: "blob",
            withCredentials: true, // Important if using cookies/JWT
          }
        );
        const blobUrl = URL.createObjectURL(response.data);
        setImageSrc(blobUrl);
      } catch (error) {
        console.error("Error fetching image blob:", error);
      }
    };

    if (filename) {
      fetchImage();
    }
  }, [filename]);

  return (
    <img
      src={imageSrc}
      alt={name}
      className="character-image"
      style={style} // Apply the style prop here
    />
  );
};

export default CharacterImage;
